export default "__VITE_ASSET__59ad0778__"